// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"922": "home","935": "about",}[chunkId] || chunkId) + "." + {"228": "089af7fd73c0eaf0","876": "8fed61443bf9f98b","922": "21da4b6875be3ffd","935": "23cf2379f9f390c7",}[chunkId] + ".js"
}